<bit-progress-bar [variant]="color" [hideStartHint]="!showText || !text" [value]="scoreWidth">
  <bit-hint slot="start">{{ text }}</bit-hint>
</bit-progress-bar>

<div aria-live="polite" class="tw-sr-only">
  {{ "passwordStrengthScore" | i18n: text }}
</div>
